import {
    GROUPS_PRODUCT_DETAIL, GROUPS_PRODUCT_INSERT, GROUPS_PRODUCT_LIST, GROUPS_PRODUCT_TREE,
    GROUPS_PRODUCT_DELETE, GROUPS_PRODUCT_UPDATE
} from './action-types';
import { PAGE_SIZE } from '../../../../constants/Config';
import Transformer from '../../../../utils/Transformer';
const initialState = {
    data: [],
    totalRows: 0,
    currentPAGE: 0,
    pageSize: PAGE_SIZE,
    tree: [],
    action: null,
    item: null
};

const reducer = (state = initialState, { type, payload = null }) => {
    switch (type) {
        case GROUPS_PRODUCT_LIST:
            return list(state, payload);
        case GROUPS_PRODUCT_TREE:
            return tree(state, payload);
        case GROUPS_PRODUCT_DETAIL:
            return detail(state, payload);
        case GROUPS_PRODUCT_UPDATE:
            return update(state, payload);
        case GROUPS_PRODUCT_INSERT:
            return insert(state, payload);
        case GROUPS_PRODUCT_DELETE:
            return deletes(state, payload);
        default:
            return state;
    }
};

function list(state, payload) {
    state = Object.assign({}, state, payload);
    return state;
}

function tree(state, payload) {
    state = Object.assign({}, state, {
        tree: payload
    });
    return state;
}

function detail(state, payload) {
    state = Object.assign({}, state, {
        item: payload
    });
    return state;
}

function insert(state, payload) {
    const insertItem = {
        id: parseInt(payload.id),
        parentId: payload.parentId,
        text: payload.name,
        children: []
    };

    const data = [...state.data, payload];

    if (payload.parentId === null) {
        state.tree = [...state.tree, insertItem];
    } else {
        Transformer.insertTree(state.tree, insertItem);
    }

    return Object.assign({}, state, { data }, { totalRows: state.totalRows + 1 });
}

function update(state, payload) {
    const data = state.data.map(obj => {
        if (obj.id === payload.id) {
            return { ...obj, ...payload };
        }
        return obj;
    });
    const tree = Transformer.updateTree(state.tree, payload);

    const item = { ...state.item, ...payload };
    return Object.assign({}, state, { data, item, tree });
}

function deletes(state, payload) {
    const data = state.data.filter(obj => obj.id !== payload);
    const tree = Transformer.deleteTree(state.tree, payload);

    return Object.assign({}, state, { data, tree }, { totalRows: state.totalRows - 1 });
}
export default reducer;
